module.exports = __webpack_public_path__ + "static/media/project16.b09768cd.jpg";